import type { Permission } from "@blis/shared/permissions";
import { hasRequiredPermissions } from "@blis/shared/permissions";

import { useAuth } from "@/features/auth/hooks";

export function PermissionGate({
  children,
  labRole = false,
  fallback = null,
  ...meta
}: {
  requiredAllPermissions?: Permission[];
  requiredAnyPermissions?: Permission[];
  requiredPermission?: Permission;
  labRole?: boolean;
  children: React.ReactNode;
  fallback?: React.ReactNode | null;
}) {
  const { user } = useAuth();

  if (
    !meta.requiredPermission &&
    !meta.requiredAllPermissions &&
    !meta.requiredAnyPermissions
  ) {
    console.warn("No permissions provided to PermissionGate");
    return fallback;
  }

  if (labRole && !user.role.startsWith("blis_lab")) {
    return fallback;
  }

  if (!hasRequiredPermissions(user.role, meta)) {
    return fallback;
  }

  return children;
}
